<template>
  <div class="con-popup" v-show="active">
    <div class="popup-background">
      <div class="popup-confirm vx-col" >
        <div class="header_popup">
          <feather-icon icon="AlertCircleIcon" class="iconStyle" ></feather-icon>
        </div>
        <div class="mid_popup">
          <strong style="font-size: 21px">{{$t('popupConfirm.titlePopup')}}</strong>
          <p class="subTitle">{{$t('popupConfirm.subtitle')}}</p>
        </div>
        <div class="footer_popup">
          <div class="vx-row">
            <vs-button class="btnAccept"  @click="onSuccess">{{$t('popupConfirm.accept2')}}</vs-button>
            <vs-button class="btnClose" @click="close" color="warning" type="border"> {{$t('popupConfirm.close')}}</vs-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PopupConfirm",
  props: {
      onSuccess: {
      type: Function,
    }
    ,active:{
      default : false
    },
    close:{
        type:Function
    }
  },
  mounted() {
    // Use the parent function directly here
    this.onSuccess();
  },
  data(){
    return{
      // active:true
    }
  },
  methods:{
  }
}
</script>

<style scoped>
.iconStyle{
  color: #FF9F43;
  transform: scale(3);
  padding-top: 12px;
}
.subTitle{
  font-size: 14px;
  line-height: 21px;
  color: #6e6c7a;
}
.footer_popup{
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: 25px;
}
.mid_popup{
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  height: 75px;
}
.btnAccept{
  width: 117px;
  height: 36px;
  font-size: 14px;
  white-space: nowrap;
  display: flex;
  justify-content: center;
}
.btnClose{
  width: 81px;
  height: 36px;
  display: flex;
  justify-content: center;
  margin-left: 70px;
}
.popup-background{
  background: rgba(0,0,0,.4);
  width: 100%;
  height: 100%;
  z-index: 10000000;
  position: fixed;
  top: 0;
  left: 0;
  display: -webkit-box;
  justify-content: center;
  align-items: center;
}
.con-popup{
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  display: -webkit-box;
  justify-content: center;
  opacity: 1;
  -webkit-transition: all .2s;
  align-items: center;
  z-index: 50000;
}
.popup-confirm{
  transition: all .2s;
  z-index: 100;
  width: 512px;
  margin: 10px;
  max-width: calc(100% - 30px);
  max-height: calc(100% - 30px);
  border-radius: 6px;
  animation: rebound .3s;
  height: 300px;
  background: rgb(255, 255, 255);
}
.header_popup{
  display: flex;
  justify-content: center;
  align-items: center;
  height: 120px;
}
</style>
